import { $getNodeByKey, $insertNodes } from 'lexical';
import { $createImageNode, $isImageNode } from './image-node';

/**
 * Updates an existing image in place. Must be called inside `editor.update`.
 * Mutating the existing node keeps it attached and re-decorates it.
 */
export function $editImageByKey(
  key: string,
  src: string,
  altText: string
): void {
  const node = $getNodeByKey(key);
  if (!$isImageNode(node)) return;
  node.setSrc(src);
  node.setAltText(altText);
}

/**
 * Inserts a new image at the caret. Must be called inside `editor.update`.
 */
export function $insertNewImage(src: string, altText: string): void {
  $insertNodes([$createImageNode({ src, altText })]);
}
